<template>
  <v-container>
    <v-row>
      <v-col>
        <v-tabs>
          <v-tab exact :to="{ name: 'SMSBroadcastRoute' }">New Message</v-tab>
          <v-tab exact :to="{ name: 'SMSBroadcastLogRoute' }">Message Log</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4">
          <v-col cols="12">
            <h2>SMS Broadcast - Message Log</h2>
            <v-divider class="py-3"></v-divider>
            <v-row>
              <v-col>
                <v-data-table
                  elevation="0"
                  :headers="headers"
                  :items="messages"
                  :items-per-page="10"
                  class="elevation-1">
                  <template v-slot:item.date="{ item }">
                    {{ new Date(item.createdAt).toLocaleDateString() }}
                  </template>
                  <template v-slot:item.message="{ item }">
                    {{ item.message }}
                  </template>
                  <template v-slot:item.group="{ item }">
                    {{ item.group }}
                  </template>
                  <template v-slot:item.location="{ item }">
                    {{ item.location ? item.location : 'All Locations' }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn x-small color="primary" @click="viewLogDetails(item)">
                      View Details
                    </v-btn>
                  </template>
                </v-data-table>
                </v-col>
            </v-row>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog
      v-if="selectedMessage"
      v-model="selectedMessageModal"
      transition="dialog-bottom-transition"
      persistent
      fullscreen
    >
      <v-card>
        <v-card-title>
          <span class="headline">Message Details</span><v-spacer></v-spacer><v-btn color="primary" @click="selectedMessageModal = false">Close</v-btn>
        </v-card-title>
        <v-card-text>
          <p><strong>Date:</strong> {{ new Date(selectedMessage.createdAt).toLocaleDateString() }}</p>
          <p><strong>Message:</strong> {{ selectedMessage.message }}</p>
          <p><strong>Group:</strong> {{ selectedMessage.group }}</p>
          <p><strong>Location:</strong> {{ selectedMessage.location ? selectedMessage.location : 'All Locations' }}</p>

          <v-row>
            <v-col>
              <v-simple-table elevation="0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Received</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="recipient in selectedMessage.sms_broadcast_logs" :key="recipient.id">
                    <td>{{ recipient.name }}</td>
                    <td>{{ recipient.to }}</td>
                    <td><v-icon v-if="recipient.received">check</v-icon></td>
                    <td>{{ recipient.error }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'SMSBroadcastLogPage',

  data () {
    return {
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Message', value: 'message' },
        { text: 'Group', value: 'group' },
        { text: 'Location', value: 'location' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      selectedMessage: null,
      selectedMessageModal: false,
    }
  },

  computed: {
    ...mapGetters({
      messages: 'sms-broadcast-message/list'
    }),
    messagesLoading() {
      return this.$store.state['sms-broadcast-message'].isFindPending
    },
  },

  methods: {
    async getMessages() {
      this.$store.dispatch('sms-broadcast-message/find', {
        query: {
          $sort: { createdAt: -1 },
          $limit: 100
        }
      })
    },
    viewLogDetails(item) {
      this.selectedMessage = item;
      this.selectedMessageModal = true;
    }
  },

  async beforeMount() {
    await this.getMessages()
  }
}
</script>

<style lang="scss">

</style>